import $ from 'jquery';

export function registerCountryListEvent(popupView, logActivity, logContext) {
  popupView.find('.toggle-country-list').on('click', (e) => {
    const $target = $(e.target);
    const $parent = $target.hasClass('icon') ? $target.parent() : $target.parentsUntil('li').parent();
    const $icon = $parent.find('.icon');
    if ($icon.hasClass('iconba-ChevronDown')) {
      $icon.removeClass('iconba-ChevronDown').addClass('iconba-ChevronUp');
    } else {
      $icon.removeClass('iconba-ChevronUp').addClass('iconba-ChevronDown');
    }
    const $country = $parent.find('.country-list');
    $country.toggle();

    if (logActivity && logActivity.trace) {
      logActivity.trace(`toggle country list of ${logContext && logContext.entity}: ${logContext && logContext.id}`);
    }

    // reposition the popup
    popupView.trigger('contentUpdated', popupView.find('.new-editorial-popup')[0].outerHTML);
  });
}
